/**
 * @author mll
 * @description 组合报表管理=>新增/编辑
 * @Date 2021/06/22
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, utils_tool } from "@/tool";
import { WizSpin } from 'wiz-components'
const { WizContainer, WizReduxTemplate, modelUtils } = framework_tool;
let { Session } = utils_tool
import { ReportConfig } from '@/components'

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/dataReport/reportConfigList/reportConfigUpd') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('reportConfigUpdateInfo', record)
      } else {
        record = Session.get('reportConfigUpdateInfo') || 0
      }
    }
  }
  return record
}

class ReportConfigForm extends WizContainer {
  componentName = "ReportConfigForm";

  constructor(props) {
    super(props);
    let initialValue = getParamRecord(props.history);
    this.state = {
      record: initialValue,
      key: new Date().getTime(),
      reportId:initialValue.id||'',
    }
    this.initialValue = initialValue;
    this.tableConfigDataList = [];
  }


  /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
  _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/dataReport/reportConfigList/reportConfigUpd') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('reportConfigUpdateInfo', initialValue)
      } else {
        initialValue = Session.get('reportConfigUpdateInfo') || {};
      }
    }
    if (initialValue.id !=  this.initialValue.id) {
      this.initialValue = initialValue;
      this.setState({reportId:initialValue.id})
      this._componentWillMount()
    }
  }

  _componentWillMount() {
    this.getTableConfigDataList();
    let initialValue = this.initialValue;
    if (initialValue && initialValue.id != null) {
      this.getReportConfigInfo(initialValue.id);
    }
  }

  getReportConfigInfo(id) {
    this.doAction({
      path: 'reportConfig/selectOneById',
      payload: {
        key: "reportConfig@selectOneById",
        apiParams: {
          id: id
        }
      }
    });
  }

  /**
   * 获取配置表基础数据
   */
  getTableConfigDataList() {
    this.doAction({
      path: 'tableConfig/getList',
      payload: {
        key: "tableConfig@DataList",
        apiParams: {
          state: 1
        }
      }
    });
  }

  propsAndStateOnChange = {
    tableConfigDataList: this._getTableConfigDataListOver.bind(this),
    saveReportConfig: this._saveOver.bind(this),
    reportConfigInfo: this._getReportConfigInfoOver.bind(this),
  }

  _getReportConfigInfoOver(nextProps, nextState) {
    if (nextProps.reportConfigInfo.code == 1) {
      let initialValue = nextProps.reportConfigInfo.data;
      this.initialValue = initialValue;
      nextState.record = initialValue;
      nextState.key=initialValue.id;
    }
    return true;
  }

  _saveOver(nextProps, nextState) {
    if (nextProps.saveReportConfig.code == 1) {
      wizNotice.success('保存成功');
      this.initialValue = [];
      this.jumpPage('replaceAndDelCrumb', '/dataReport/reportConfigList');
    } else {
      wizNotice.error('提交失败：' + nextProps.saveReportConfig.msg);
    }
    return true;
  }

  _getTableConfigDataListOver(nextProps, nextState) {
    if (nextProps.tableConfigDataList.code == 1) {
      this.tableConfigDataList = nextProps.tableConfigDataList.data;
      nextState.key=new Date().getTime();
    }
    return true;
  }

  /**
   * 提交方法回调
   */
  _submit = (e) => {
    console.log('submit1:', e);
    let fitterValues = this.fitterFieldsValue(e);
    console.log('submit2:', fitterValues);
    let apiPath = "reportConfig/add";
    if (this.initialValue.id) {
      apiPath = "reportConfig/update"
    }
    this.doAction({
      path: apiPath,
      payload: {
        key: 'saveReportConfig',
        apiParams: {
          ...fitterValues
        }
      }
    });
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    return fitterValues;
  }

  _render() {
    const { record ,key} = this.state;
    let { tableConfigLoading,reportConfigLoading } = this.props
    let baseTableList = this.tableConfigDataList;
    return <WizSpin tip={'加载中'} spinning={tableConfigLoading||reportConfigLoading}>
      <ReportConfig key={key||''} {...record} baseTableList={baseTableList} submit={(e) => {
        this._submit(e)
      }} />
    </WizSpin>;
  }
}


const mapStateToProps = (state, ownProps) => {
  const { tableConfig, reportConfig } = state;
  const tableConfigDataList = modelUtils.getModelEntity(tableConfig, "tableConfig@DataList");
  const reportConfigInfo = modelUtils.getModelEntity(reportConfig, "reportConfig@selectOneById");
  const saveReportConfig = modelUtils.getModelEntity(reportConfig, "saveReportConfig");
  const load = modelUtils.getLoadingState(state, ['tableConfig', 'reportConfig']);
  return {
    tableConfigDataList,
    reportConfigInfo,
    saveReportConfig,
    ...load
  };
};

export default connect(mapStateToProps)(ReportConfigForm);
